export const AC = {
  BirthDay: 'bday-day',
  BirthMonth: 'bday-month',
  BirthYear: 'bday-year',
  City: 'address-level2',
  Country: 'country',
  Email: 'email',
  FirstName: 'given-name',
  HonorificPrefix: 'honorific-prefix',
  Landline: 'tel',
  LastName: 'family-name',
  Off: 'nope',
  PostalCode: 'postal-code',
  StreetAddress: 'street-address',
  Password: 'current-password',
} as const;
